// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.transactions-page {
  display: grid;
  gap: 20px;
  max-width: 100%;
  margin: 0;
  width: 100%;
  overflow: hidden;
}

.transactions-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.transactions-header.toolbar--title {
  min-height: 56px;
  padding-top: 10px;
  padding-bottom: 10px;
}

.transactions-header.toolbar--title .pill-btn {
  min-height: 34px;
  padding-top: 0;
  padding-bottom: 0;
}

.transactions-stats {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 16px;
  width: 100%;
}

.transactions-block {
  display: grid;
  gap: 18px;
  padding: 18px;
  border-radius: 22px;
  border: 1px solid rgba(148, 163, 184, 0.25);
  background: rgba(255, 255, 255, 0.7);
  box-shadow: 0 18px 40px rgba(15, 23, 42, 0.12);
  width: 100%;
}

.stat-card {
  padding: 16px;
  border-radius: 18px;
  background: linear-gradient(135deg, #0f172a, #1f2937);
  color: #f8fafc;
  box-shadow: 0 20px 40px rgba(15, 23, 42, 0.2);
}

.stat-label {
  font-weight: 600;
  color: #cbd5f5;
  display: inline-flex;
  gap: 8px;
  align-items: center;
  font-size: 0.9rem;
}

.stat-value {
  font-size: 2rem;
  font-weight: 800;
  margin-top: 8px;
}

.stat-sub {
  margin-top: 6px;
  color: #94a3b8;
  font-size: 0.85rem;
}

.transactions-graph-card,
.transactions-table-card {
  background: #0b1220;
  border-radius: 20px;
  border: 1px solid rgba(148, 163, 184, 0.2);
  box-shadow: 0 30px 60px rgba(15, 23, 42, 0.2);
  padding: 18px;
  color: #e2e8f0;
  overflow: hidden;
}

.transactions-graph-header,
.transactions-table-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: 700;
  margin-bottom: 12px;
}

.graph-meta {
  color: #94a3b8;
  font-size: 0.85rem;
}

.transactions-graph {
  height: 420px;
  border-radius: 16px;
  overflow: hidden;
  background: radial-gradient(circle at top, rgba(30, 64, 175, 0.25), rgba(15, 23, 42, 0.9));
}

.dataspace-connections-visual {
  height: clamp(440px, 48vw, 620px);
  border-radius: 16px;
  background:
    radial-gradient(circle at 48% 32%, rgba(30, 64, 175, 0.28), rgba(30, 64, 175, 0) 44%),
    linear-gradient(180deg, #0b1220 0%, #0f172a 62%, #111827 100%);
  position: relative;
  overflow: hidden;
  cursor: grab;
  touch-action: none;
  -webkit-user-select: none;
          user-select: none;
}

.dataspace-connections-visual.is-dragging {
  cursor: grabbing;
}

.dataspace-connections-visual canvas {
  position: absolute;
  inset: 0;
  z-index: 1;
  width: 100%;
  height: 100%;
  display: block;
}

.dataspace-connections-core {
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 20;
  width: min(286px, 36%);
  aspect-ratio: 1 / 1;
  transform: translate(-50%, -50%);
  display: grid;
  place-items: center;
  align-content: center;
  gap: 7px;
  pointer-events: none;
  border: 1px solid rgba(226, 232, 240, 0.16);
  border-radius: 999px;
  background:
    radial-gradient(
      circle at 50% 50%,
      rgba(226, 232, 240, 0.08) 0%,
      rgba(226, 232, 240, 0.025) 58%,
      rgba(226, 232, 240, 0) 72%
    );
  box-shadow:
    inset 0 0 42px rgba(15, 23, 42, 0.45),
    0 0 44px rgba(147, 197, 253, 0.12);
}

.dataspace-connections-core__title {
  color: #f8fafc;
  font-size: clamp(13px, 1.5vw, 18px);
  font-weight: 900;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  text-shadow:
    0 0 14px rgba(147, 197, 253, 0.62),
    0 2px 8px rgba(15, 23, 42, 0.95);
}

.dataspace-connections-core__root {
  max-width: 72%;
  overflow: hidden;
  color: #cbd5e1;
  font-size: 0.76rem;
  font-weight: 700;
  line-height: 1.25;
  text-align: center;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dataspace-connections-labels {
  position: absolute;
  inset: 0;
  z-index: 30;
  pointer-events: none;
}

.dataspace-pod-label {
  position: absolute;
  top: 0;
  left: 0;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  max-width: min(260px, 34vw);
  padding: 7px 9px;
  border: 1px solid rgba(148, 163, 184, 0.28);
  border-radius: 12px;
  background: rgba(15, 23, 42, 0.74);
  color: #e2e8f0;
  box-shadow: 0 12px 28px rgba(15, 23, 42, 0.28);
  backdrop-filter: blur(8px);
  transition: opacity 0.16s ease;
}

.dataspace-pod-label__dot {
  width: 10px;
  height: 10px;
  flex: 0 0 10px;
  border-radius: 999px;
  background: #f8fafc;
  box-shadow: 0 0 16px rgba(248, 250, 252, 0.78);
}

.dataspace-pod-label--self {
  border-color: rgba(251, 146, 60, 0.42);
  background: rgba(30, 41, 59, 0.82);
  box-shadow:
    0 14px 32px rgba(15, 23, 42, 0.36),
    0 0 22px rgba(251, 146, 60, 0.16);
}

.dataspace-pod-label--self .dataspace-pod-label__dot {
  width: 12px;
  height: 12px;
  flex-basis: 12px;
  background: #ffb366;
  box-shadow: 0 0 18px rgba(251, 146, 60, 0.9);
}

.dataspace-pod-label--incoming .dataspace-pod-label__dot {
  background: #93c5fd;
  box-shadow: 0 0 16px rgba(147, 197, 253, 0.8);
}

.dataspace-pod-label--mixed .dataspace-pod-label__dot {
  background: #e2e8f0;
}

.dataspace-pod-label__body {
  min-width: 0;
  display: grid;
  gap: 2px;
}

.dataspace-pod-label__body strong,
.dataspace-pod-label__body span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dataspace-pod-label__body strong {
  color: #f8fafc;
  font-size: 0.82rem;
}

.dataspace-pod-label__body span {
  color: #94a3b8;
  font-size: 0.72rem;
  font-weight: 700;
}

.dataspace-connections-empty {
  position: absolute;
  left: 50%;
  bottom: 22px;
  z-index: 35;
  transform: translateX(-50%);
  padding: 8px 12px;
  border: 1px solid rgba(148, 163, 184, 0.24);
  border-radius: 999px;
  background: rgba(15, 23, 42, 0.68);
  color: #94a3b8;
  font-size: 0.86rem;
  font-weight: 700;
}

.dataspace-hover-tooltip {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 60;
  display: grid;
  min-width: 220px;
  max-width: min(460px, 58vw);
  gap: 3px;
  padding: 9px 11px;
  border: 1px solid rgba(148, 163, 184, 0.3);
  border-radius: 12px;
  background: rgba(15, 23, 42, 0.86);
  color: #e2e8f0;
  box-shadow: 0 14px 32px rgba(15, 23, 42, 0.36);
  opacity: 0;
  pointer-events: none;
  backdrop-filter: blur(9px);
  transition: opacity 0.12s ease;
}

.dataspace-hover-tooltip strong,
.dataspace-hover-tooltip span,
.dataspace-hover-tooltip small {
  overflow-wrap: anywhere;
  white-space: normal;
}

.dataspace-hover-tooltip strong {
  color: #f8fafc;
  font-size: 0.84rem;
}

.dataspace-hover-tooltip span {
  color: #cbd5e1;
  font-size: 0.76rem;
  font-weight: 700;
}

.dataspace-hover-tooltip small {
  color: #94a3b8;
  font-size: 0.7rem;
  font-weight: 700;
}

.dataspace-connections-legend {
  position: absolute;
  right: 16px;
  bottom: 14px;
  z-index: 45;
  display: inline-grid;
  gap: 7px;
  padding: 9px 11px;
  border: 1px solid rgba(148, 163, 184, 0.22);
  border-radius: 12px;
  background: rgba(15, 23, 42, 0.68);
  color: #cbd5e1;
  font-size: 0.76rem;
  font-weight: 800;
  pointer-events: none;
  backdrop-filter: blur(8px);
}

.dataspace-legend-item {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.dataspace-legend-dot {
  width: 10px;
  height: 10px;
  border-radius: 999px;
  background: #ffb366;
  box-shadow: 0 0 16px rgba(251, 146, 60, 0.85);
}

.dataspace-legend-line {
  width: 22px;
  height: 3px;
  border-radius: 999px;
  background: #ffb366;
}

.dataspace-connections-visual--fallback {
  background:
    radial-gradient(circle at 40% 50%, rgba(251, 146, 60, 0.42) 0 2px, transparent 3px),
    radial-gradient(circle at 62% 44%, rgba(248, 250, 252, 0.56) 0 3px, transparent 4px),
    linear-gradient(180deg, #0b1220 0%, #111827 100%);
  background-size: 56px 56px, 72px 72px, auto;
}

.transactions-table {
  display: grid;
  gap: 8px;
  overflow-x: auto;
}

.transactions-row {
  display: grid;
  grid-template-columns: 120px minmax(180px, 1.4fr) minmax(160px, 1.2fr) 140px 120px;
  gap: 10px;
  padding: 10px 12px;
  border-radius: 14px;
  background: rgba(15, 23, 42, 0.6);
  align-items: center;
}

.transactions-row--head {
  background: rgba(15, 23, 42, 0.9);
  font-size: 0.85rem;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: #94a3b8;
}

.dir-pill {
  display: inline-flex;
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 0.8rem;
  font-weight: 700;
  text-transform: capitalize;
}

.dir-incoming {
  background: rgba(56, 189, 248, 0.2);
  color: #38bdf8;
}

.dir-outgoing {
  background: rgba(168, 85, 247, 0.2);
  color: #c084fc;
}

.transactions-empty {
  padding: 16px;
  border-radius: 14px;
  background: rgba(15, 23, 42, 0.6);
  text-align: center;
  color: #94a3b8;
}

.transactions-error {
  padding: 12px 16px;
  border-radius: 14px;
  background: #fee2e2;
  color: #b91c1c;
}

.transactions-inbox {
  font-size: 0.85rem;
  color: #64748b;
}

.transactions-inbox a {
  color: #2563eb;
  text-decoration: none;
}

.transactions-inbox a:hover {
  text-decoration: underline;
}

.mono {
  font-family: "SF Mono", "Menlo", "Consolas", monospace;
  font-size: 0.85rem;
}

@media (max-width: 720px) {
  .dataspace-connections-visual {
    height: 420px;
  }

  .dataspace-connections-core {
    width: min(230px, 52%);
  }

  .dataspace-pod-label {
    max-width: min(220px, 44vw);
    padding: 6px 8px;
  }

  .dataspace-pod-label__body strong {
    font-size: 0.76rem;
  }

  .dataspace-pod-label__body span {
    font-size: 0.68rem;
  }

  .dataspace-hover-tooltip {
    max-width: 60vw;
  }

  .dataspace-connections-legend {
    right: 10px;
    bottom: 10px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/TransactionHistory.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,SAAS;EACT,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,2CAA2C;EAC3C,oCAAoC;EACpC,8CAA8C;EAC9C,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qDAAqD;EACrD,cAAc;EACd,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,QAAQ;EACR,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;;EAEE,mBAAmB;EACnB,mBAAmB;EACnB,0CAA0C;EAC1C,6CAA6C;EAC7C,aAAa;EACb,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,0FAA0F;AAC5F;;AAEA;EACE,iCAAiC;EACjC,mBAAmB;EACnB;;kEAEgE;EAChE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,sBAAsB;EACtB,mBAAmB;EACnB,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,QAAQ;EACR,oBAAoB;EACpB,2CAA2C;EAC3C,oBAAoB;EACpB;;;;;;KAMG;EACH;;sCAEoC;AACtC;;AAEA;EACE,cAAc;EACd,mCAAmC;EACnC,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB;;oCAEkC;AACpC;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,2BAA2B;EAC3B,gBAAgB;EAChB,2CAA2C;EAC3C,mBAAmB;EACnB,kCAAkC;EAClC,cAAc;EACd,8CAA8C;EAC9C,0BAA0B;EAC1B,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,sCAAsC;EACtC,kCAAkC;EAClC;;qCAEmC;AACrC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,QAAQ;AACV;;AAEA;;EAEE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,WAAW;EACX,2BAA2B;EAC3B,iBAAiB;EACjB,2CAA2C;EAC3C,oBAAoB;EACpB,kCAAkC;EAClC,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,2BAA2B;EAC3B,QAAQ;EACR,iBAAiB;EACjB,0CAA0C;EAC1C,mBAAmB;EACnB,kCAAkC;EAClC,cAAc;EACd,8CAA8C;EAC9C,UAAU;EACV,oBAAoB;EACpB,0BAA0B;EAC1B,8BAA8B;AAChC;;AAEA;;;EAGE,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,oBAAoB;EACpB,QAAQ;EACR,iBAAiB;EACjB,2CAA2C;EAC3C,mBAAmB;EACnB,kCAAkC;EAClC,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,WAAW;EACX,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE;;;qDAGmD;EACnD,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,kFAAkF;EAClF,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iCAAiC;EACjC,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,sDAAsD;EACtD,kBAAkB;AACpB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,2BAA2B;IAC3B,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF","sourcesContent":[".transactions-page {\n  display: grid;\n  gap: 20px;\n  max-width: 100%;\n  margin: 0;\n  width: 100%;\n  overflow: hidden;\n}\n\n.transactions-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.transactions-header.toolbar--title {\n  min-height: 56px;\n  padding-top: 10px;\n  padding-bottom: 10px;\n}\n\n.transactions-header.toolbar--title .pill-btn {\n  min-height: 34px;\n  padding-top: 0;\n  padding-bottom: 0;\n}\n\n.transactions-stats {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n  gap: 16px;\n  width: 100%;\n}\n\n.transactions-block {\n  display: grid;\n  gap: 18px;\n  padding: 18px;\n  border-radius: 22px;\n  border: 1px solid rgba(148, 163, 184, 0.25);\n  background: rgba(255, 255, 255, 0.7);\n  box-shadow: 0 18px 40px rgba(15, 23, 42, 0.12);\n  width: 100%;\n}\n\n.stat-card {\n  padding: 16px;\n  border-radius: 18px;\n  background: linear-gradient(135deg, #0f172a, #1f2937);\n  color: #f8fafc;\n  box-shadow: 0 20px 40px rgba(15, 23, 42, 0.2);\n}\n\n.stat-label {\n  font-weight: 600;\n  color: #cbd5f5;\n  display: inline-flex;\n  gap: 8px;\n  align-items: center;\n  font-size: 0.9rem;\n}\n\n.stat-value {\n  font-size: 2rem;\n  font-weight: 800;\n  margin-top: 8px;\n}\n\n.stat-sub {\n  margin-top: 6px;\n  color: #94a3b8;\n  font-size: 0.85rem;\n}\n\n.transactions-graph-card,\n.transactions-table-card {\n  background: #0b1220;\n  border-radius: 20px;\n  border: 1px solid rgba(148, 163, 184, 0.2);\n  box-shadow: 0 30px 60px rgba(15, 23, 42, 0.2);\n  padding: 18px;\n  color: #e2e8f0;\n  overflow: hidden;\n}\n\n.transactions-graph-header,\n.transactions-table-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-weight: 700;\n  margin-bottom: 12px;\n}\n\n.graph-meta {\n  color: #94a3b8;\n  font-size: 0.85rem;\n}\n\n.transactions-graph {\n  height: 420px;\n  border-radius: 16px;\n  overflow: hidden;\n  background: radial-gradient(circle at top, rgba(30, 64, 175, 0.25), rgba(15, 23, 42, 0.9));\n}\n\n.dataspace-connections-visual {\n  height: clamp(440px, 48vw, 620px);\n  border-radius: 16px;\n  background:\n    radial-gradient(circle at 48% 32%, rgba(30, 64, 175, 0.28), rgba(30, 64, 175, 0) 44%),\n    linear-gradient(180deg, #0b1220 0%, #0f172a 62%, #111827 100%);\n  position: relative;\n  overflow: hidden;\n  cursor: grab;\n  touch-action: none;\n  user-select: none;\n}\n\n.dataspace-connections-visual.is-dragging {\n  cursor: grabbing;\n}\n\n.dataspace-connections-visual canvas {\n  position: absolute;\n  inset: 0;\n  z-index: 1;\n  width: 100%;\n  height: 100%;\n  display: block;\n}\n\n.dataspace-connections-core {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  z-index: 20;\n  width: min(286px, 36%);\n  aspect-ratio: 1 / 1;\n  transform: translate(-50%, -50%);\n  display: grid;\n  place-items: center;\n  align-content: center;\n  gap: 7px;\n  pointer-events: none;\n  border: 1px solid rgba(226, 232, 240, 0.16);\n  border-radius: 999px;\n  background:\n    radial-gradient(\n      circle at 50% 50%,\n      rgba(226, 232, 240, 0.08) 0%,\n      rgba(226, 232, 240, 0.025) 58%,\n      rgba(226, 232, 240, 0) 72%\n    );\n  box-shadow:\n    inset 0 0 42px rgba(15, 23, 42, 0.45),\n    0 0 44px rgba(147, 197, 253, 0.12);\n}\n\n.dataspace-connections-core__title {\n  color: #f8fafc;\n  font-size: clamp(13px, 1.5vw, 18px);\n  font-weight: 900;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  text-shadow:\n    0 0 14px rgba(147, 197, 253, 0.62),\n    0 2px 8px rgba(15, 23, 42, 0.95);\n}\n\n.dataspace-connections-core__root {\n  max-width: 72%;\n  overflow: hidden;\n  color: #cbd5e1;\n  font-size: 0.76rem;\n  font-weight: 700;\n  line-height: 1.25;\n  text-align: center;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.dataspace-connections-labels {\n  position: absolute;\n  inset: 0;\n  z-index: 30;\n  pointer-events: none;\n}\n\n.dataspace-pod-label {\n  position: absolute;\n  top: 0;\n  left: 0;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  max-width: min(260px, 34vw);\n  padding: 7px 9px;\n  border: 1px solid rgba(148, 163, 184, 0.28);\n  border-radius: 12px;\n  background: rgba(15, 23, 42, 0.74);\n  color: #e2e8f0;\n  box-shadow: 0 12px 28px rgba(15, 23, 42, 0.28);\n  backdrop-filter: blur(8px);\n  transition: opacity 0.16s ease;\n}\n\n.dataspace-pod-label__dot {\n  width: 10px;\n  height: 10px;\n  flex: 0 0 10px;\n  border-radius: 999px;\n  background: #f8fafc;\n  box-shadow: 0 0 16px rgba(248, 250, 252, 0.78);\n}\n\n.dataspace-pod-label--self {\n  border-color: rgba(251, 146, 60, 0.42);\n  background: rgba(30, 41, 59, 0.82);\n  box-shadow:\n    0 14px 32px rgba(15, 23, 42, 0.36),\n    0 0 22px rgba(251, 146, 60, 0.16);\n}\n\n.dataspace-pod-label--self .dataspace-pod-label__dot {\n  width: 12px;\n  height: 12px;\n  flex-basis: 12px;\n  background: #ffb366;\n  box-shadow: 0 0 18px rgba(251, 146, 60, 0.9);\n}\n\n.dataspace-pod-label--incoming .dataspace-pod-label__dot {\n  background: #93c5fd;\n  box-shadow: 0 0 16px rgba(147, 197, 253, 0.8);\n}\n\n.dataspace-pod-label--mixed .dataspace-pod-label__dot {\n  background: #e2e8f0;\n}\n\n.dataspace-pod-label__body {\n  min-width: 0;\n  display: grid;\n  gap: 2px;\n}\n\n.dataspace-pod-label__body strong,\n.dataspace-pod-label__body span {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.dataspace-pod-label__body strong {\n  color: #f8fafc;\n  font-size: 0.82rem;\n}\n\n.dataspace-pod-label__body span {\n  color: #94a3b8;\n  font-size: 0.72rem;\n  font-weight: 700;\n}\n\n.dataspace-connections-empty {\n  position: absolute;\n  left: 50%;\n  bottom: 22px;\n  z-index: 35;\n  transform: translateX(-50%);\n  padding: 8px 12px;\n  border: 1px solid rgba(148, 163, 184, 0.24);\n  border-radius: 999px;\n  background: rgba(15, 23, 42, 0.68);\n  color: #94a3b8;\n  font-size: 0.86rem;\n  font-weight: 700;\n}\n\n.dataspace-hover-tooltip {\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 60;\n  display: grid;\n  min-width: 220px;\n  max-width: min(460px, 58vw);\n  gap: 3px;\n  padding: 9px 11px;\n  border: 1px solid rgba(148, 163, 184, 0.3);\n  border-radius: 12px;\n  background: rgba(15, 23, 42, 0.86);\n  color: #e2e8f0;\n  box-shadow: 0 14px 32px rgba(15, 23, 42, 0.36);\n  opacity: 0;\n  pointer-events: none;\n  backdrop-filter: blur(9px);\n  transition: opacity 0.12s ease;\n}\n\n.dataspace-hover-tooltip strong,\n.dataspace-hover-tooltip span,\n.dataspace-hover-tooltip small {\n  overflow-wrap: anywhere;\n  white-space: normal;\n}\n\n.dataspace-hover-tooltip strong {\n  color: #f8fafc;\n  font-size: 0.84rem;\n}\n\n.dataspace-hover-tooltip span {\n  color: #cbd5e1;\n  font-size: 0.76rem;\n  font-weight: 700;\n}\n\n.dataspace-hover-tooltip small {\n  color: #94a3b8;\n  font-size: 0.7rem;\n  font-weight: 700;\n}\n\n.dataspace-connections-legend {\n  position: absolute;\n  right: 16px;\n  bottom: 14px;\n  z-index: 45;\n  display: inline-grid;\n  gap: 7px;\n  padding: 9px 11px;\n  border: 1px solid rgba(148, 163, 184, 0.22);\n  border-radius: 12px;\n  background: rgba(15, 23, 42, 0.68);\n  color: #cbd5e1;\n  font-size: 0.76rem;\n  font-weight: 800;\n  pointer-events: none;\n  backdrop-filter: blur(8px);\n}\n\n.dataspace-legend-item {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.dataspace-legend-dot {\n  width: 10px;\n  height: 10px;\n  border-radius: 999px;\n  background: #ffb366;\n  box-shadow: 0 0 16px rgba(251, 146, 60, 0.85);\n}\n\n.dataspace-legend-line {\n  width: 22px;\n  height: 3px;\n  border-radius: 999px;\n  background: #ffb366;\n}\n\n.dataspace-connections-visual--fallback {\n  background:\n    radial-gradient(circle at 40% 50%, rgba(251, 146, 60, 0.42) 0 2px, transparent 3px),\n    radial-gradient(circle at 62% 44%, rgba(248, 250, 252, 0.56) 0 3px, transparent 4px),\n    linear-gradient(180deg, #0b1220 0%, #111827 100%);\n  background-size: 56px 56px, 72px 72px, auto;\n}\n\n.transactions-table {\n  display: grid;\n  gap: 8px;\n  overflow-x: auto;\n}\n\n.transactions-row {\n  display: grid;\n  grid-template-columns: 120px minmax(180px, 1.4fr) minmax(160px, 1.2fr) 140px 120px;\n  gap: 10px;\n  padding: 10px 12px;\n  border-radius: 14px;\n  background: rgba(15, 23, 42, 0.6);\n  align-items: center;\n}\n\n.transactions-row--head {\n  background: rgba(15, 23, 42, 0.9);\n  font-size: 0.85rem;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  color: #94a3b8;\n}\n\n.dir-pill {\n  display: inline-flex;\n  padding: 4px 10px;\n  border-radius: 999px;\n  font-size: 0.8rem;\n  font-weight: 700;\n  text-transform: capitalize;\n}\n\n.dir-incoming {\n  background: rgba(56, 189, 248, 0.2);\n  color: #38bdf8;\n}\n\n.dir-outgoing {\n  background: rgba(168, 85, 247, 0.2);\n  color: #c084fc;\n}\n\n.transactions-empty {\n  padding: 16px;\n  border-radius: 14px;\n  background: rgba(15, 23, 42, 0.6);\n  text-align: center;\n  color: #94a3b8;\n}\n\n.transactions-error {\n  padding: 12px 16px;\n  border-radius: 14px;\n  background: #fee2e2;\n  color: #b91c1c;\n}\n\n.transactions-inbox {\n  font-size: 0.85rem;\n  color: #64748b;\n}\n\n.transactions-inbox a {\n  color: #2563eb;\n  text-decoration: none;\n}\n\n.transactions-inbox a:hover {\n  text-decoration: underline;\n}\n\n.mono {\n  font-family: \"SF Mono\", \"Menlo\", \"Consolas\", monospace;\n  font-size: 0.85rem;\n}\n\n@media (max-width: 720px) {\n  .dataspace-connections-visual {\n    height: 420px;\n  }\n\n  .dataspace-connections-core {\n    width: min(230px, 52%);\n  }\n\n  .dataspace-pod-label {\n    max-width: min(220px, 44vw);\n    padding: 6px 8px;\n  }\n\n  .dataspace-pod-label__body strong {\n    font-size: 0.76rem;\n  }\n\n  .dataspace-pod-label__body span {\n    font-size: 0.68rem;\n  }\n\n  .dataspace-hover-tooltip {\n    max-width: 60vw;\n  }\n\n  .dataspace-connections-legend {\n    right: 10px;\n    bottom: 10px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
